import ColorConfig from '../../../../config/ColorConfig'

const getBarColors = (values: number[]) => {
	return values.map(() => ColorConfig.Primary)
}


export default getBarColors
